import { TableHead, TableRow } from '@mui/material';
import { TableColumn, TableProps } from '../Table.props';
import { TableHeaderCell } from './TableHeaderCell';

export interface TableHeaderProps<T> {
  columns: TableColumn<T>[];
  sorting?: TableProps<T>['sorting'];
  allSelected?: boolean;
  onSelectAll?: (checked: boolean) => void;
  stickyHeader?: boolean;
  columnStickyPositions?: Map<string | keyof T, number>;
}

/**
 * TableHeader - Renders the complete table header section
 *
 * Features:
 * - Renders all header cells including selection and actions
 * - Handles sorting functionality
 * - Manages select all functionality
 * - Proper composition of header cells
 */
export const TableHeader = <T,>({
  columns,
  sorting,
  allSelected,
  onSelectAll,
  stickyHeader = true,
  columnStickyPositions,
}: TableHeaderProps<T>) => {
  return (
    <TableHead
      sx={{
        ...(stickyHeader && {
          '& .MuiTableCell-root': {
            position: 'sticky',
            top: 0,
            zIndex: 3, // Regular sticky header
          },
        }),
      }}
    >
      <TableRow>
        {columns.map((column) => (
          <TableHeaderCell
            key={String(column.id)}
            column={column}
            sorting={sorting}
            allSelected={allSelected}
            onSelectAll={onSelectAll}
            stickyPosition={columnStickyPositions?.get(column.id)}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};
